import LinkedAccountGroupTemplate from '@/features/agent/linked_accounts/templates/LinkedAccountGroupTemplate';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/agent/linked_accounts/new/group/$groupKey')({
  component: LinkedAccountNewGroup,
  staticData: { title: '連携先追加' },
});

function LinkedAccountNewGroup() {
  const { groupKey } = Route.useParams();

  return <LinkedAccountGroupTemplate groupKey={groupKey} />;
}
